import type { Theme } from '@mui/material';

export const styles = {
  wrapper: {
    hr: (theme: Theme) => ({
      borderBottomWidth: '2px',
      borderColor: theme.colors.neutral[400],
    }),
  },

  toggleButtonGroup: (gridColumns: number) => (theme: Theme) => ({
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'grid',
      gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
      justifyContent: 'center',
      justifyItems: 'center',
      gridGap: '40px',
    },

    // Due to the missing variant prop on ToggleButtons the styles cannot be provided as a variant
    button: {
      backgroundColor: theme.colors.neutral[200],
      color: theme.colors.black,
      width: '100%',
      borderColor: 'transparent !important',

      // Override Mui toggle button borders
      borderRadius: '4px !important',

      '&:hover': {
        backgroundColor: theme.colors.neutral[300],
      },

      '&:active': {
        backgroundColor: theme.colors.neutral[400],
      },

      '&.Mui-selected': {
        backgroundColor: theme.colors.secondary[400],

        '&:hover': {
          backgroundColor: theme.colors.secondary[500],
        },
      },
    },
  }),

  gridItem: (gridColumn: number, gridRow: number) => (theme: Theme) => ({
    mb: 2,
    [theme.breakpoints.up('sm')]: {
      mb: 0,
      // Backwards compatibility for old browsers
      gridColumn: gridColumn,
      gridRow: gridRow,
    },
  }),
};
